import request from 'assets/js/http';

//轮次查询
export function roundList(data) {
  return request({
    url: `/common/roundList`,
    method: 'post',
    data
  });
}

//轮次管理
export function roundManage(data) {
  return request({
    url: `/common/roundManage`,
    method: 'post',
    data
  });
}
